<template>
  <div>
    <!-- 初始提示弹窗 -->
    <div class="update_prompt">
      <el-dialog
        @close="closePop"
        :visible.sync="updateDatalist"
        title="温馨提示"
        :close-on-click-modal="false"
      >
        <!-- <div class="contents">
          <p>尊敬的用户，您好！</p>
          <p>
            由于公司产品调整，为了给您更好的产品体验，决定于
            <span>2023年1月1日</span>
            将"学习云”APP<span>替换</span>为
            <span>"医考拉"</span>
            APP，届时将会下架"学习云’APP，请各位用户尽快下载"医考拉"APP进行使用，给您带来不便，敬请谅解!
          </p>
          <div class="qr">
            <img src="@/assets/ykl_qr.png" alt="" />
          </div>
        </div> -->
        <div class="main">
          <h2>2023春节放假通知</h2>
          <p>尊敬的用户，您好！</p>
          <p>
            春节临近，我们公司放假时间为
            <span>2023年1月19日至2023年1月27日，</span>
            放假期间客服信息回复可能会有延迟，给您造成的不便敬请谅解。<span>1月28日（星期六）正常上班</span>，我们将第一时间给您提供服务。
          </p>
        </div>
        <div class="button_view">
          <el-button @click="updateDatalist = false">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      updateDatalist: false, // 更新提示弹窗
    };
  },
  methods: {
    openReport() {},
    closePop() {},
  },
};
</script>

<style lang="scss" scoped>

::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.update_prompt {
  &::v-deep .el-dialog {
    width: 30% !important;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    // line-height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  .contents {
    p {
      line-height: 22px;
      span {
        color: red;
      }
    }
    .qr {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 300px;
        height: 300px;
      }
    }
  }
}
.main {
  h2 {
    color: #409eff;
    text-align: center;
    margin-bottom: 12px;
  }
  p {
    font-size: 16px;
    padding: 0px 24px;

    &:nth-child(2) {
      margin-bottom: 12px;
    }
    &:nth-child(3) {
    }
    span {
      color: red;
    }
  }
 
}
 .button_view {
   margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    >.el-button{
      background: #409eff;
      color: #fff;
    }
  }
</style>
